// TODO old code this whole file needs to be changed and it will be done in a separate task
// import { createLogger, format, transports } from 'winston';

// const enumerateErrorFormat = format((info) => {
//   if (info.message instanceof Error) {
//     info.message = Object.assign(
//       {
//         message: info.message.message,
//         stack: info.message.stack
//       },
//       info.message
//     );
//   }

//   if (info instanceof Error) {
//     return Object.assign(
//       {
//         message: info.message,
//         stack: info.stack
//       },
//       info
//     );
//   }

//   return info;
// });

// const logger = createLogger({
//   level: 'info',
//   format: format.combine(enumerateErrorFormat(), format.json()),
//   transports: [new transports.Console()]
// });

const logger = {
  error: () => {
    console.error('Some error occurred');
  }
};

export default logger;
